<template>
    <div v-if="dataOptions.type ==='select'">
    <div class="input-field"  v-if="dataSource === 'code'">
       <div class="select-label" v-if="showLabel">{{dataOptions.label}}</div>
        <select
          :disabled="dataDisabled"
          :multiple="isMultiple"
          @change="$_updateValues()"
          :name="dataOptions.label.toLowerCase()"
          :id="dataOptions.label.toLowerCase()"
          v-model="dataValues"
        >
        <option selected v-if="isMultiple && dataOptions.multiInitial" :disabled="true" value="">{{dataOptions.multiInitial}}</option>
          <option
            :value="option"
            :selected="option === dataValues"
            v-for="(option, index) in dataOptions.options"
            v-bind:key="index * 2.12231"
          >{{option.name}}</option>
        </select>
         <span class="helper-text" :class="this.dataValid ? 'green-text': 'red-text'" v-if="dataOptions.helperText">
        {{!this.dataValid ? dataOptions.helperText.e : dataOptions.helperText.s}}
       </span>
       
      </div>
      <div v-else class="input-field">
         <div class="select-label" v-if="showLabel">{{dataOptions.name}}</div>
        <select
          :disabled="dataDisabled"
          @change="$_updateValuesWeb()"
          :name="dataOptions.name.toLowerCase()"
          :id="dataOptions.name.toLowerCase()"
          v-model="dataValues"
        >
          <option
            :value="option.option"
            :selected="option === dataValues"
            v-for="(option, index) in dataOptions.options"
            v-bind:key="index * 2.12231"
          >{{option.option}}</option>
        </select>
        <span class="helper-text" :class="this.dataValid ? 'green-text': 'red-text'" v-if="dataOptions.helperText">
        {{!this.dataValid ? dataOptions.helperText.e : dataOptions.helperText.s}}
       </span>
       
      </div>
    </div>      
</template>
<script>
import M from 'materialize-css'
export default {
  name:'selectField',
  props:{
    dataSource:{
      type:String,
      default:'code'
    },
    dataValid:{
      type: Boolean,
      default: false
    },
    dataDisabled:{
      type:Boolean,
      default:false,
    },
    isMultiple:{
      type:Boolean,
      default:false
    },
    dataClass:{
      type: String,
      default:''
    },
    showLabel:{
      type:Boolean,
      default:true,
    },
    dataOptions:{
      type:[Array, Object]
    },
  },
  data(){
    let vm = this
    return{
      dataValues:vm.isMultiple ? [] : '',
      selectInstances:false,
    }
  },
  watch:{
    dataValid: function (){
      setTimeout(() => {
        this.$el.querySelector('input').classList.add(this.dataValid ? 'valid': 'invalid')
      }, 100);
    //  window.console.log(nV)
    },  
    dataDisabled:function(){
      this.selectInstances.destroy()
      setTimeout(() => {
        this.$_initFormFields()
      }, 200);
    }
  },
  mounted(){
  this.dataValues = this.dataOptions.values 
    setTimeout(() => {
        this.$_initFormFields()
    },100);
  },
  beforeDestroy(){
    this.selectInstances
    ? this.selectInstances.destroy()
    : false
  },
  methods:{
    $_updateValues(){
      this.$emit('update',{values:this.dataValues,property:this.dataOptions.name})
    },
    $_updateValuesWeb(){
      this.$emit('update',{values:this.dataValues,property:this.dataOptions.name})
    },
    $_initFormFields() {
      let elems = this.$el.querySelector("select");
      this.selectInstances = M.FormSelect.init(elems);
    }
  }
}
</script>
<style lang="scss">
.select-label {
  color: #9e9e9e;
  position: absolute;
  top: -6px;
  left: 2px;
  font-size: 1rem;
  cursor: text;
  transition: color .2s ease-out, -webkit-transform .2s ease-out;
  transform-origin: 0% 100%;
  text-align: initial;
  transform: translateY(-14px);
}
</style>